import {
  ComboForRangeType,
  PokerRange,
  RangeType,
} from 'features/ranges/ranges.type';
import BPCHandMatrix from './BPCHandMatrix';
import { useState } from 'react';
import { StyleProps } from '@chakra-ui/react';
import { Combo } from './HandMatrix';

export default function BPCHandMatrixEditable({
  rangeDetails,
  selectedRangeType,
  onChange,
  style,
}: Readonly<{
  rangeDetails: PokerRange['details'];
  selectedRangeType?: ComboForRangeType;
  onChange: (newDetails: PokerRange['details']) => void;
  style?: StyleProps;
}>) {
  const [isPointerDown, setIsPointerDown] = useState(false);

  function onComboSelect(combo: Combo, allowUnselection = true) {
    if (!selectedRangeType) {
      onChange({
        ...rangeDetails,
        [combo]: undefined,
      });
      return;
    }

    let currentComboDetails = rangeDetails[combo] || {};
    const newWeight = selectedRangeType.weight / 100;

    // J'ai le droit de supprimer des valeurs (je viens de cliquer, je ne suis pas entrain de glisser) => je supprimer l'entrée du détail du combo
    if (
      allowUnselection &&
      currentComboDetails[selectedRangeType.type] &&
      currentComboDetails[selectedRangeType.type] === newWeight
    ) {
      delete currentComboDetails[selectedRangeType.type];
    }
    // On est dans le cas du coloriage d'une case complete
    else if (newWeight === 1) {
      currentComboDetails = { [selectedRangeType.type]: newWeight || 1 };
    }
    // A partir d'ici newWeight <1 => on essaye de colorier la moitié d'une case
    else {
      //On commence par supprimer l'entrée actuelle pour voir si on aura assez de place
      delete currentComboDetails[selectedRangeType.type];
      const totalCurrentWeight = Object.values(currentComboDetails).reduce(
        (acc, val) => acc + val,
        0,
      );
      // Si besoin on fait de la place en réduisant les autres entrées
      if (totalCurrentWeight + newWeight > 1) {
        const spaceLeft = 1 - totalCurrentWeight;
        const spaceToFree = newWeight - spaceLeft;
        Object.keys(currentComboDetails).forEach((rangeType) => {
          currentComboDetails[rangeType as RangeType] =
            (currentComboDetails[rangeType as RangeType] ?? 0) * spaceToFree;
        });
      }
      currentComboDetails[selectedRangeType.type] = newWeight;
    }

    onChange({
      ...rangeDetails,
      [combo]: currentComboDetails,
    });
  }

  return (
    <BPCHandMatrix
      style={style}
      rangeDetails={rangeDetails}
      onPointerDown={(combo) => {
        if (!combo) {
          return;
        }
        setIsPointerDown(true);
        onComboSelect(combo, true);
      }}
      onPointerUp={() => {
        setIsPointerDown(false);
      }}
      onPointerEnter={(combo) =>
        isPointerDown && combo ? onComboSelect(combo, false) : undefined
      }
    />
  );
}
